import { useCallback } from 'react';

import { onContextMenuCopyButtonClicked } from '../../../common/utils/events/context-menu-copy-button-clicked';
import { getExtensionData } from '../../../common/utils/relay/get-extension-data';
import { useAnalytics, useCommonAndPrivateAttributes } from '../../analytics';
import type { SharedEventAttributes } from '../../analytics/prepared-result-attributes';
import type { AnalyticsEventCallbacks } from '../../analytics/result-analytics-callbacks';
/**
 * @returns a callback to fire an event when the result
 * context menu copy button is clicked by the user.
 */

export const useFireContextMenuCopyButtonClickedWithAttributes = (
	sharedEventAttributes: SharedEventAttributes,
	eventCallbacks: AnalyticsEventCallbacks,
): (() => void) => {
	const { commonAttributes, nonPrivacySafeAttributes } = sharedEventAttributes;
	const { fireAnalyticsEvent } = eventCallbacks;
	return useCallback(() => {
		fireAnalyticsEvent(
			onContextMenuCopyButtonClicked({
				commonAttributes: {
					...commonAttributes,
					...getExtensionData(commonAttributes.isCQL),
				},
				nonPrivacySafeAttributes,
			}),
		);
	}, [fireAnalyticsEvent, commonAttributes, nonPrivacySafeAttributes]);
};

export const useFireContextMenuCopyButtonClicked = (): (() => void) => {
	const sharedEventAttributes = useCommonAndPrivateAttributes();
	const { fireAnalyticsEvent } = useAnalytics();
	return useFireContextMenuCopyButtonClickedWithAttributes(sharedEventAttributes, {
		fireAnalyticsEvent,
	});
};
